import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Link from '../../../Core/Link';
import ProductStep from '../../Cards/ProductStep';
import chevronRightBlack from '../../../../images/chevron-right-black.svg';
import chevronRightDisabled from '../../../../images/chevron-right-disabled.svg';
import chevronLeftBlack from '../../../../images/chevron-left-black.svg';
import chevronLeftDisabled from '../../../../images/chevron-left-disabled.svg';

export const StyledContainer = styled(Container)`
  /* temporary fix for background color - May 3rd 2021 */
  &.columns-4-wrapper {
    > div:first-of-type {
      margin: 0 auto;
    }
  }
  overflow-x: hidden;
  width: 100%;
`;

export const Heading = styled.div`
  margin-bottom: 48px;

  > h1,
  > h2,
  > h3 {
    margin-bottom: 20px;
  }

  &.center-aligned,
  &.center {
    text-align: center;
  }

  > p {
    text-align: center;
  }

  /* temporary fix for background color - May 3rd 2021 */
  &.columns-4 {
    padding-top: 42px;
  }
`;

export const Grid = styled.div`
  position: relative;
  margin: 0 auto 2rem;
  max-width: 440px;
  &.columns-4 {
    padding-bottom: 42px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: flex;
    justify-content: space-around;
    display: grid;
    align-items: center;
    justify-items: center;
    max-width: 100%;
    column-gap: 24px;
    row-gap: 25px;

    &.columns-3 {
      grid-template-columns: repeat(3, 1fr [column]);
    }

    &.columns-4 {
      grid-template-columns: repeat(4, 1fr [column]);
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    column-gap: 26px;
    row-gap: 56px;
  }
`;

export const CarouselControls = styled.div`
  display: block;
  margin: 1rem auto;

  @media only screen and (min-width: 769px) {
    display: none;
  }
  ul {
    display: flex;
    justify-content: center;
    align-items: center;

    li {
      margin: 0 1rem;
    }

    li:not(:first-child) {
      margin-top: 0;
    }
  }
`;

export const CarouselBtn = styled.button`
  width: 17px;
  height: 16px;
  &.previous-carousel {
    background-image: url(${chevronLeftBlack});
    &:disabled {
      background-image: url(${chevronLeftDisabled});
    }
  }
  &.next-carousel {
    background-image: url(${chevronRightBlack});
    &:disabled {
      background-image: url(${chevronRightDisabled});
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 2rem auto;

  h2,
  h3 {
    color: ${themeGet('colors.velvet')};
    margin: 0 0 30px 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    align-items: center;
    justify-content: center;

    h2,
    h3 {
      margin: 0 30px 0 0;
    }
  }
`;

export const Btn = styled(Link)``;

export const StyledPhone = styled(ProductStep)`
  position: relative;
  text-align: center;

  img {
    max-height: 408px;
    width: 100%;
    object-fit: contain;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${Grid}.columns-4 & {
      &:not(:last-child) {
        &::after {
          right: -15%;
          top: 5%;
        }
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    &:not(:last-child) {
      &::after {
        right: -8%;
      }
    }
    ${Grid}.columns-4 & {
      &:not(:last-child) {
        &::after {
          right: -11%;
          top: 6%;
        }
      }
    }
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    &:not(:last-child) {
      &::after {
        right: -6%;
      }
    }
    ${Grid}.columns-4 & {
      &:not(:last-child) {
        &::after {
          right: -8.5%;
        }
      }
    }
  }
`;

export const StepContainers = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: none;
  }
`;

export const StepNumber = styled.div`
  background-color: ${({ theme }) => theme.colors.velvet};
  ${StyledContainer}.product-step-red &,
  ${StepContainers}.pc-red & {
    background-color: ${({ theme }) => theme.colors['pc-red']};
  }
  border-radius: 100%;
  height: 32px;
  width: 32px;
  margin: 0 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.2;
  &.active {
    opacity: 1;
  }

  p {
    /* font-weight: ${({ theme }) => theme.fontWeights.medium}; */
    font-variant: tabular-nums;
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
    line-height: 1;
    font-size: 24px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    opacity: 1;
  }
`;
